import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import ModalFormRevInterna from '../Modals/ModalFormRevInterna/ModalFormRevInterna';
import ModalFormEntregueAoCliente from '../Modals/ModalFormEntregueAoCliente/ModalFormEntregueAoCliente';
import ModalFormEntregueAoEp from '../Modals/ModalFormEntregueAoEp/ModalFormEntregueAoEp';
import ModalFormGestaoTecnica from '../Modals/ModalFormGestaoTecnica/ModalFormGestaoTecnica';
import ModalFormCorrecaoInterna from '../Modals/ModalFormCorrecaoInterna/ModalFormCorrecaoInterna';
import ModalFormAprovacaoDoCliente from '../Modals/ModalFormAprovacaoDoCliente/ModalFormAprovacaoDoCliente';
import ModalFormAutorizarFaturamento from '../Modals/ModalFormAutorizarFaturamento/ModalFormAutorizarFaturamento';
import ModalElaborado from '../Modals/ModalElaborado/ModalElaborado';
import { useParams } from 'react-router-dom';
import oikosApi from '../../services/oikos'
import qs from 'qs';
import moment from 'moment';
import { getLinkEvidencia, getLinkProdFinal, downloadFile, PROD_COORDENADOR_PF_FIELDS, oikosGet } from '../../utils/fc';
import { notifyError, notifySuccess } from '../../utils/notify';
import {
  avaliarDesfazerEtapaProduto,
  canDesfazerEtapaProduto,
  desfazerEtapaProduto,
} from '../../utils/desfazerEtapaProduto';
import { correctionMark, correctionSegmentColor, TL_GREEN, TL_YELLOW, TL_MUTED } from './timelineColors';



const ModalForm = ( props ) => {
  switch (props.actual) {
    case 1: {
      if (props.item.step === 2) {
        return <ModalElaborado {...props}/>
      }
      return <></>
    }
    case 2: {
      if (props.item.step === 2) {
        return <ModalFormEntregueAoEp {...props}/>
      }
      return <></>
    }
    case 3: {
      if (props.item.step === 4) {
        return <ModalFormRevInterna {...props}/>
      }
      return <></>
    }
    case 4: {
      if (props.item.step === 5) {
        return <ModalFormGestaoTecnica {...props}/>
      }
      return <></>
    }
    case 5: {
      if (props.item.step === 6) {
        return <ModalFormEntregueAoCliente {...props}/>
      }
      return <></>
    }
    case 6: {
      if (props.item.step === 7) {
        return <ModalFormAprovacaoDoCliente {...props}/>
      }
      return <></>
    }
    case 7: {
      if (props.item.step === 8) {
        return <ModalFormAutorizarFaturamento {...props} orcRubr_id={props.orcRubr_id} />
      }
      return <></>
    }
    case 8: {
      return <></>
    }
    case 9: {
      if (props.item.step === 2) {
        return <ModalFormCorrecaoInterna {...props}/>
      }
      return <></>
    }
    default: return <></>
  }
};

ModalForm.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
  }),
  actual: PropTypes.number,
};

const Circle = ( props ) => {

  if (Number(props.actual) === 9) {
    const mark = correctionMark(props.item.step, props.produto)
    const hover = {
      onMouseEnter: () => {
        props.setIsHovered(true);
        props.getStatusInfo();
      },
      onMouseLeave: () => props.setIsHovered(false),
    }
    if (mark === 'green') {
      return <i className="ri-checkbox-circle-fill ri-xl text-success" {...hover} />
    }
    if (mark === 'yellow') {
      return <i className="ri-checkbox-circle-fill ri-xl text-warning" {...hover} />
    }
    return <i className="ri-checkbox-blank-circle-line ri-xl" style={{ color: TL_MUTED }} {...hover} />
  }

  if ((props.item.step === 4 && props.produto.prod_aprovCompliance === 1) ||
  (props.item.step === 5 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 4) ||
  (props.item.step === 7 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 6) ||
  ((props.item.step === 7 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.produto.prodStatusPenultimo_id === 9) ||
  (((props.item.step === 7 || props.item.step === 6) && props.actual === 9 && props.produto.hasStatus6 !== 0)) ||
  ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 !== 0)) ||
  (props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 9))
  {
    return (
      <>
        <i className="ri-checkbox-circle-fill ri-xl text-warning"
        onMouseEnter={() => {
          props.setIsHovered(true);
          props.getStatusInfo();
        }}
        onMouseLeave={() => props.setIsHovered(false)}
        />
      </>
    )
  }

  if ((props.item.step === 6 || props.item.step === 7) && props.actual === 9 && props.produto.prodStatusPenultimo_id !== 6) {
    return (
      <>
        <i className="ri-checkbox-blank-circle-line ri-xl"
        style={{ color: '#adb5bd' }}
        onMouseEnter={() => {
          props.setIsHovered(true);
          props.getStatusInfo();
        }}
        onMouseLeave={() => props.setIsHovered(false)}
        />
      </>
    );
  }

  if (((props.item.step <= props.actual) && props.actual !== 9 && props.actual !== 1 && props.actual !== 2) ||
  (props.item.step === 1 && props.actual === 2) ||
  ((props.actual === 9) && (props.item.step === 1 || props.item.step === 2 || props.item.step === 3) && (props.produto.prodStatusPenultimo_id === 3)) ||
  ((props.actual === 9) && (props.item.step === 1 || props.item.step === 2 || props.item.step === 4) && (props.produto.prodStatusPenultimo_id === 4)) ||
  ((props.actual === 9) && (props.item.step < 7) && (props.item.step !== 4) && (props.produto.prodStatusPenultimo_id === 6)) ||
  ((props.actual === 9) && (props.item.step < 7) && (props.item.step === 4) && (props.produto.prodStatusPenultimo_id === 6) && props.produto.prod_aprovCompliance !== 1) ||
  (props.item.step === 3 && props.actual >= 3)
) {
  return (
    <>
      <i className="ri-checkbox-circle-fill ri-xl text-success"
      onMouseEnter={() => {
        props.setIsHovered(true);
        props.getStatusInfo();
      }}
      onMouseLeave={() => props.setIsHovered(false)}
      />
    </>
  );
}

if ((props.item.step === (props.actual + 1) && props.actual !== 1 && props.actual !== 9 && props.actual !== 3 && props.item.step !== 3) ||
(props.actual === 3 && props.item.step === 4) ||
(props.item.step === props.actual && props.actual === 2) ||
(props.item.step === props.actual && props.actual === 1)) {
    return (
      <>
        <i className="ri-checkbox-blank-circle-line ri-xl text-success"
        onMouseEnter={() => {
          props.setIsHovered(true);
          props.getStatusInfo();
        }}
        onMouseLeave={() => props.setIsHovered(false)}
        >
        </i>
      </>
  );

  }

  return <i className="ri-checkbox-blank-circle-line ri-xl" style={{ color: '#adb5bd' }} />;
};

Circle.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const HorizontalLineLeft = (props) => {

  return (
    <div
    className="d-flex flex-grow-1"
    style={{
      height: 2,
      backgroundColor: Number(props.actual) === 9
        ? correctionSegmentColor(props.item.step, 'left', props.produto)
        :
      (props.actual === 9 && props.item.step === 6 && props.produto.prodStatusPenultimo_id === 6) ? '#339933' :
      (props.actual === 9 && props.item.step === 6 && props.produto.prodStatusPenultimo_id === 6) ? '#339933' :
      (props.actual === 3 && props.item.step === 4) ? '#339933' :
      (props.actual === 2 && props.item.step === 2) ? '#339933' :
      ((props.actual === 9) && (props.item.step < 7) && (props.item.step !== 1) && (props.produto.prodStatusPenultimo_id === 6)) ? '#339933' :
      ((props.actual === 9) && (props.item.step <= 4) && (props.produto.prodStatusPenultimo_id === 4) && (props.item.step !== 1)) ? '#339933' :
      ((props.actual === 9) && (props.item.step < 4) && (props.produto.prodStatusPenultimo_id === 3) && (props.item.step !== 1)) ? '#339933' :
      (props.actual === 9 && props.item.step > 4 && props.item.step !== 6 && props.item.step !== 7 && props.item.step !== 5) ? '#979933' :
      (props.item.step === 7 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 6) ? '#979933':
      ((props.item.step === 5 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 4)) ? '#979933' :
      ((props.item.step === 4 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 3)) ? '#979933' :
      ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 9)) ? '#979933' :
      (((props.item.step === 7 || props.item.step === 6 )&& props.actual === 9 && props.produto.hasStatus6 !== 0)) ? '#979933' :
      ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 !== 0)) ? '#979933' :
      ((props.item.step === 7 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.produto.prodStatusPenultimo_id === 9) ? '#979933' :
      ((props.actual === 9 && props.item.step === 6) || (props.actual === 9 && props.item.step === 7)) ? '#ced4da' :
      props.item.step === 1 ? 'transparent' :
      (props.item.step <= (props.actual + 1) && props.actual !== 9  && props.actual !== 1 && props.actual !== 2 ) || (props.item.step === 7 && props.actual === 6) ? '#339933' : '#ced4da',
    }}
  />
  )
};

HorizontalLineLeft.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const HorizontalLineRight = (props) => {

  return (
    <div
    className="d-flex flex-grow-1"
    style={{
      height: 2,
      backgroundColor: Number(props.actual) === 9
        ? correctionSegmentColor(props.item.step, 'right', props.produto)
        :
        (props.actual === 9 && props.item.step === 6 && props.produto.prodStatusPenultimo_id === 6) ? '#339933' :
        (props.actual === 2 && props.item.step === 2) ? '#ced4da' :
        (props.actual === 9 && props.item.step > 4 && props.item.step !== 6 && props.item.step !== 7 && props.item.step !== 5) ? '#979933' :
        ((props.actual === 9 && (props.item.step === 6 || props.item.step === 5) && props.produto.hasStatus6 === 0) || (props.item.step === 5 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 === 0 )) ? '#ced4da' :
        ((props.item.step === 6 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 9)) ? '#979933' :
        (props.actual === 9 && (props.item.step === 6 || props.item.step === 5) && props.produto.hasStatus6 !== 0) ? '#979933' :
        ((props.item.step === 4 || props.item.step === 5) && props.actual === 9 && props.produto.prodStatusPenultimo_id === 3) ? '#ced4da' :
        ((props.item.step === 5 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.produto.prodStatusPenultimo_id === 9) ? '#979933' :
        ((props.item.step === 5 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.actual === 9) ? '#979933' :
        ((props.item.step === 6 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 !== 0)) ? '#979933' :
        (props.item.step === 1 && props.actual === 1) ? '#ced4da' :
        props.item.step === 8
          ? 'transparent'
          : (props.item.step <= props.actual)
            ? '#339933'
            : '#ced4da',
    }}
  />
  );
}

HorizontalLineRight.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const Label = (props) => {

  return (
    <>
      <span
      style={{
        fontSize: 12,
        width: 100,
        textAlign: 'center',
        fontWeight: (props.item.step === (props.actual + 1) && props.actual !== 1 && props.item.step !== 3 && props.actual !== 9) ||
        (props.actual === 9 && props.item.step === 2 && props.produto.prodStatusPenultimo_id === 3) ? '600' : 'normal',
        color: Number(props.actual) === 9
          ? (correctionMark(props.item.step, props.produto) === 'green'
            ? TL_GREEN
            : correctionMark(props.item.step, props.produto) === 'yellow'
              ? TL_YELLOW
              : TL_MUTED)
          :
        ((props.actual === 9 && props.item.step === 5 && props.produto.prodStatusPenultimo_id === 4) || (props.actual === 9 && props.item.step === 7 && props.produto.prodStatusPenultimo_id === 6)) ? '#979933' :
        ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 9)) ? '#979933' :
        ((props.item.step === 7 && props.actual === 5 && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 !== 0)) ? '#979933' :
        ((props.item.step === 4 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 3)) ? '#979933' :
        (props.item.step === 2 && props.actual === 1) ? '#adb5bd' :
        (((props.item.step === 5 || props.item.step === 6 || props.item.step === 7) && props.actual === 9 && props.produto.prodStatusPenultimo_id === 3)) ? '#adb5bd' :
        ((props.actual === 9 && (props.item.step === 6 || props.item.step === 7) && props.produto.prodStatusPenultimo_id === 4 && props.produto.hasStatus6 === 0)) ? '#ced4da' :
        (props.item.step <= props.actual && props.actual !== 9) ? '#339933' :
        ((props.actual === 9) && (props.item.step < 7) && (props.produto.prodStatusPenultimo_id === 6)) ? '#339933' :
        ((props.actual === 9) && (props.item.step <= 4) && (props.produto.prodStatusPenultimo_id === 4)) ? '#339933' :
        (props.actual === 9 && props.item.step < 4 && props.produto.prodStatusPenultimo_id === 3) ? '#339933' :
        ((props.item.step === 7 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.produto.prodStatusPenultimo_id === 9) ? '#979933' :
        ((props.item.step === 7 || props.item.step === 6) && props.produto.hasStatus6 !== 0 && props.actual === 9) ? '#979933' :
        (props.item.step === (props.actual + 1) && props.actual >= 3) ? '#339933' : '#adb5bd',
      }}
      onMouseEnter={() => {
        props.setIsHovered(true);
        props.getStatusInfo();
      }}
      onMouseLeave={() => {
        props.setIsHovered(false)
      }}
      >
        {props.item.label}
      </span>

    </>
  );
}

Label.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
    label: PropTypes.string,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const Data = (props) => {

  const [statusData, setStatusData] = useState(null);

  useEffect(() => {
    console.log(props.produto.prodStatusAlt_data)
    /*
    axios.get(`http://localhost:3001/prodStatusAlt/${prod_id}/${props.item.step+1}`, {withCredentials: true})
     .then( result => {
       setStatusData(result.data.prodStatusAlt_data)
     })
    */
  }, [])

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

    return (
      <>
        {props.item.step < props.actual ?
          (props.produto.prodStatusAlt_data &&
            <p
            style={{
              margin: '0 auto',
              fontSize: 12,
              width: 100,
              textAlign: 'center',
              fontWeight: props.item.step === props.actual ? '600' : 'normal',
              color: props.item.step <= props.actual ? '#339933' : '#adb5bd',
            }}
          >
            {formatDate(props.produto.prodStatusAlt_data)}
          </p>
          )
          : <></>
        }
      </>
    )
}

Data.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
    label: PropTypes.string,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const Correcao = (props) => {
      if ((props.item.step === 5 && props.actual === 9) || (props.item.step === 7 && props.actual === 9 && props.produto.prodStatusPenultimo_id === 6)) {
        return <p>Em correção interna...</p>;
      }
    }

Correcao.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
    label: PropTypes.string,
  }),
  prod_aprovCompliance: PropTypes.number,
  actual: PropTypes.number,
};

const Step = (props) => {
  const [isHovered, setIsHovered] = useState(false);
  const [statusInfo, setStatusInfo] = useState(null);
  const [openResume, setOpenResume] = useState(false);

  const getStatusInfo = async () => {
    const res = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "prodStatusAlt",
          data: {
            prod_id: props.produto.prod_id,
            prodStatusTp_id: props.item.step,
            prodStatusAlt_ativo: 1,
          },
          fields: {
            '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = prodStatusAlt.prodStatusAlt_usuarioCria)': 'prod_responsavelNome',
          }
        })}`
      );

    if (res.data.length === 0) return;

    let info = res.data[0];

    if (props.item.step === 4) {
      const notas = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "prodComplianceAval",
          data: {
            prodStatusAlt_id: info.prodStatusAlt_id,
          }
        })}`
      );

      info = {...info, ...notas.data[0]}
    }

    if (props.item.step === 5) {
      const notas = await oikosApi.get(
        `/?${qs.stringify({
          action: "get",
          table: "prodGestaoAval",
          data: {
            prodStatusAlt_id: info.prodStatusAlt_id,
          }
        })}`
      );

      info = {...info, ...notas.data[0]}
    }

    setStatusInfo(info);
  }

  return (
    <Col className='text-center' style={{ padding: 0, minWidth: "100px"}}>
      <div style={{ width: '100%', height: 5, paddingTop: "7px", marginBottom: "5px" }} className="d-flex flex-row align-items-center">
        <HorizontalLineLeft {...props} />
        <Circle {...props} setIsHovered={setIsHovered} getStatusInfo={getStatusInfo}/>
        <HorizontalLineRight {...props} />
      </div>
      <Label {...props} setIsHovered={setIsHovered} getStatusInfo={getStatusInfo}/>
      {
        isHovered && statusInfo &&
        <div className='d-flex' style={{
            padding: "10px",
            textAlign:"start",
            backgroundColor: "#f1f5f7",
            position: "absolute",
            top: "40px", left: "-100px",
            zIndex: 20,
            borderRadius: "15px",
            border: "1px solid #757575",
            color: '#505a62',
            fontSize: "12px",
            minWidth: "210px",
            maxWidth: "300px",
            justifyContent: "space-between",
            fontFamily: 'Roboto, sans-serif'
          }}>
          <div className="d-flex flex-column justify-content-start">
            <span>Movimentado em: </span>
            <br />
            {(props.item.step === 4 || props.item.step === 5 || props.item.step === 7 || props.item.step === 8) &&
              <>
                <span>Parecer</span>
                <br />
              </>
            }
            <span>Responsável: </span>
          </div>
          <div className="d-flex flex-column justify-content-end">
            <strong className='text-right'>{moment(`${statusInfo.prodStatusAlt_data}`).format('DD/MM/YYYY')}</strong>
            <br />
            {(props.item.step === 4 || props.item.step === 5 || props.item.step === 7 || props.item.step === 8) &&
              <>
                {(statusInfo.prodComplianceAval_aprov === 0 || statusInfo.prodGestaoAval_aprovEP === 0 || (props.item.step === 7 && props.produto.prodStatusActual_id === 7) || (props.item.step === 8 && props.produto.prodStatusActual_id === 8)) ?
                  <span className='pl-2 pr-2 text-center' style={{fontSize: "10px", backgroundColor: "#bbd259", color: "#339933", borderRadius: "5px"}}>Aprovado</span> :
                  <span className='pl-2 pr-2 text-center' style={{fontSize: "10px", backgroundColor: "#fcb92c", color: "#7d5e2d", borderRadius: "5px"}}>Reprovado</span>
                }
                <br />
              </>
            }
            <strong className='text-right'>{statusInfo.prod_responsavelNome}</strong>
          </div>
        </div>
      }
      <div style={{ marginTop: "10px" }}>
        <ModalForm {...props}/>
      </div>
    </Col>
  )
};

Step.propTypes = {
  item: PropTypes.shape({
    step: PropTypes.number,
    label: PropTypes.string,
  }),
};

const StepProgress = (props) => {

  const [prod, setProd] = useState(props.produto);
  const [prodFinaisLinks, setProdFinaisLinks] = useState([]);
  const [evidenceLinks, setEvidenceLinks] = useState([]);
  const [count, setCount] = useState(0);
  const [verMaisProds, setVerMaisProds] = useState(false);
  const [verMaisPareceres, setVerMaisPareceres] = useState(false);
  const [undoOpen, setUndoOpen] = useState(false);
  const [undoLoading, setUndoLoading] = useState(false);
  const [undoEval, setUndoEval] = useState(null);
  const [undoEvalLoading, setUndoEvalLoading] = useState(false);

  const podeDesfazerPerm = canDesfazerEtapaProduto({
    userCargo: props.userCargo,
    permId: props.permId,
  });

  const getProdLatest = async () => {
    const produto = await oikosGet({
      action: 'get',
      table: 'prod',
      data: {
        prod_id: props.produto.prod_id,
        prod_ativo: 1,
      },
      fields: {
        "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
        'prod_responsavel_email',
        "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
        'prod_responsavelNome',
        '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))': 'prod_responsavelNomeAtual',
        '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))': 'prod_responsavel_email_atual',
        ...PROD_COORDENADOR_PF_FIELDS,
        //'(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)': 'prodStatusTp_nome',
        '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)':
        'prodStatusActual_id',
        "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1 OFFSET 1)":
        "prodStatusPenultimo_id",
        '(SELECT psa.prodStatusAlt_obs FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusAlt_obs',
        '(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusAlt_data',
        '(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prodStatusTp_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusAlt_data',
        '(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 3 LIMIT 1)': 'prodStatus3_data',
        '(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 4 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatus4_data',
        '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 6)': 'hasStatus6',
        '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 5)': 'hasStatus5',
        "(SELECT rec_aut FROM rec WHERE rec.rec_id = prod.rec_id AND rec.rec_ativo = 1 LIMIT 1)": "rec_aut",
      }
    });

    setProd(produto.data[0]);

    const links = await getLinkProdFinal(props.produto.prod_id);
    setProdFinaisLinks(links);

    const evidenceLinks = await getLinkEvidencia(props.produto.prod_id);
    setEvidenceLinks(evidenceLinks);
  }

  useEffect(()=>{

    getProdLatest();
    console.log(prod);
    console.log(count);

  }, [count])

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!podeDesfazerPerm || !props.produto?.prod_id) {
        setUndoEval(null);
        return;
      }
      setUndoEvalLoading(true);
      try {
        const produtoAtualLocal = { ...props.produto, ...(prod?.prod_id ? prod : {}) };
        const result = await avaliarDesfazerEtapaProduto(produtoAtualLocal);
        if (!cancelled) setUndoEval(result);
      } catch (e) {
        console.log(e);
        if (!cancelled) {
          setUndoEval({ ok: false, reason: 'Não foi possível verificar se há etapa para desfazer.' });
        }
      } finally {
        if (!cancelled) setUndoEvalLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [count, prod, props.produto?.prod_id, props.produto?.rec_id, props.produto?.prod_aprovCompliance, podeDesfazerPerm]);

  const handleOpenUndo = () => {
    if (!undoEval?.ok || undoLoading) return;
    setUndoOpen(true);
  };

  const handleConfirmUndo = async () => {
    if (!undoEval?.ok || undoLoading) return;
    setUndoLoading(true);
    try {
      const produtoAtualLocal = { ...props.produto, ...(prod?.prod_id ? prod : {}) };
      const result = await desfazerEtapaProduto({
        produto: produtoAtualLocal,
        userOikosId: props.userOikosId,
      });
      const destino = result.etapaDestinoNome || 'etapa anterior';
      notifySuccess(
        result.recRevertida
          ? `Etapa "${result.etapaNome}" desfeita. Autorização de faturamento revertida na receita. Produto voltou para: ${destino}.`
          : `Etapa "${result.etapaNome}" desfeita. Produto voltou para: ${destino}.`
      );
      setUndoOpen(false);
      setCount((prev) => prev + 1);
      if (props.onProductTimelineChanged) props.onProductTimelineChanged();
    } catch (e) {
      console.log(e);
      notifyError(e?.message || 'Falha ao desfazer a etapa.');
    } finally {
      setUndoLoading(false);
    }
  };

  const handleCertificate = async (url) => {
    try {
      const zipBlob = await getZip(url);
      console.log('ZIP received:', zipBlob);
      await postZip(zipBlob);
      console.log('ZIP sent successfully');
    } catch (err) {
      console.error('Error sending ZIP:', err);
    }
  }

  const getZip = async (url) => {

    console.log(url)

    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to get zip.`);
    const blob = await response.blob();

    return blob;
  };

  const postZip = async (zipBlob) => {
    const formData = new FormData();
    formData.append('file', zipBlob);

    const response = await fetch('https://proxy-service-236688625650.southamerica-east1.run.app', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to post ZIP: ${errorText}`);
    }
  };

  const produtoAtual = { ...props.produto, ...(prod?.prod_id ? prod : {}) };

  return (
    <>
      <Row style={{ marginLeft: 1, marginRight: 0 }}>
        <a target='_blank' href={`${props.produto.prod_drive}`}>
            <Button
            title="Pasta do produto"
            className="ml-2"
            color="light"
            size="sm"
            >
              <i className="ri-folder-2-line" />
            </Button>
          </a><br />
        <Step item={{ step: 1, label: 'Não Iniciado' }}
          projeto={props.projeto}
          actual={produtoAtual.prodStatusActual_id || 0}
          dataContratual={moment(produtoAtual.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={moment(produtoAtual.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={moment(produtoAtual.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome}
          prod_aprovCompliance={produtoAtual.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={produtoAtual.prodStatusAlt_obs}
          produto={produtoAtual}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
          onProductTimelineChanged={props.onProductTimelineChanged}
        />
        <Step item={{ step: 2, label: 'Em Elaboração' }}
          projeto={props.projeto}
          actual={produtoAtual.prodStatusActual_id || 0}
          dataContratual={moment(produtoAtual.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={moment(produtoAtual.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={moment(produtoAtual.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome}
          prod_aprovCompliance={produtoAtual.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={produtoAtual.prodStatusAlt_obs}
          produto={produtoAtual}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
          onProductTimelineChanged={props.onProductTimelineChanged}
        />
        <Step item={{ step: 3, label: 'Entregue ao EP' }}
          projeto={props.projeto}
          actual={produtoAtual.prodStatusActual_id || 0}
          dataContratual={moment(produtoAtual.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={moment(produtoAtual.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={moment(produtoAtual.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome}
          prod_aprovCompliance={produtoAtual.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={produtoAtual.prodStatusAlt_obs}
          produto={produtoAtual}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
          onProductTimelineChanged={props.onProductTimelineChanged}
        />
        <Step item={{ step: 4, label: 'Revisão Interna' }}
          projeto={props.projeto}
          actual={produtoAtual.prodStatusActual_id || 0}
          dataContratual={moment(produtoAtual.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={moment(produtoAtual.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={moment(produtoAtual.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome}
          prod_aprovCompliance={produtoAtual.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={produtoAtual.prodStatusAlt_obs}
          produto={produtoAtual}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
          onProductTimelineChanged={props.onProductTimelineChanged}
        />
        <Step item={{ step: 5, label: 'Gestão Técnica' }}
          projeto={props.projeto}
          actual={produtoAtual.prodStatusActual_id || 0}
          dataContratual={moment(produtoAtual.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={moment(produtoAtual.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={moment(produtoAtual.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome}
          prod_aprovCompliance={produtoAtual.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={produtoAtual.prodStatusAlt_obs}
          produto={produtoAtual}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
          onProductTimelineChanged={props.onProductTimelineChanged}
        />
        <Step item={{ step: 6, label: 'Entregue ao Cliente' }}
          projeto={props.projeto}
          actual={produtoAtual.prodStatusActual_id || 0}
          dataContratual={moment(produtoAtual.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={moment(produtoAtual.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={moment(produtoAtual.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome}
          prod_aprovCompliance={produtoAtual.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={produtoAtual.prodStatusAlt_obs}
          produto={produtoAtual}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
          onProductTimelineChanged={props.onProductTimelineChanged}
        />
        <Step item={{ step: 7, label: 'Aprovado pelo Cliente' }}
          projeto={props.projeto}
          actual={produtoAtual.prodStatusActual_id || 0}
          dataContratual={moment(produtoAtual.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={moment(produtoAtual.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={moment(produtoAtual.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome}
          prod_aprovCompliance={produtoAtual.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={produtoAtual.prodStatusAlt_obs}
          produto={produtoAtual}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
          orcRubr_id={props.orcRubr_id}
          projectProducts={props.projectProducts}
          onProductTimelineChanged={props.onProductTimelineChanged}
        />
        <Step item={{ step: 8, label: 'Faturamento Autorizado' }}
          projeto={props.projeto}
          actual={produtoAtual.prodStatusActual_id || 0}
          dataContratual={moment(produtoAtual.prod_dtContrato).format('DD/MM/YYYY')}
          dataEntregueAoEp={moment(produtoAtual.prodStatus3_data).format('DD/MM/YYYY')}
          dataEntregueAGestao={moment(produtoAtual.prodStatus4_data).format('DD/MM/YYYY')}
          tecResp={props.produto.prod_responsavelNome}
          prod_aprovCompliance={produtoAtual.prod_aprovCompliance}
          userOikosId={props.userOikosId}
          prodStatusAlt_obs={produtoAtual.prodStatusAlt_obs}
          produto={produtoAtual}
          setCount={setCount}
          linksEvidencias={evidenceLinks}
          linksProdutos={prodFinaisLinks}
          orcRubr_id={props.orcRubr_id}
          projectProducts={props.projectProducts}
          onProductTimelineChanged={props.onProductTimelineChanged}
        />

        {
          /*
          props.produto.prodStatusActual_id >= 4 && props.produto.prodStatusActual_id !== 9 &&
        <Button
          type="button"
          color="light"
          className="waves-effect"
          onClick={() => handleCertificate(`https://oikos.ecoss.is/oikos/${prodFinaisLinks[prodFinaisLinks.length - 1]}`)}
        >
          <span style={{fontSize: '13px'}}>Criar Certificado</span>
        </Button>
        */
        }
      </Row>

      {podeDesfazerPerm && (
        <Row className="mt-2 ml-1 align-items-center">
          <Col xs="auto" className="pl-0">
            <Button
              type="button"
              color="light"
              size="sm"
              disabled={undoEvalLoading || undoLoading || !undoEval?.ok}
              title={
                undoEvalLoading
                  ? 'Verificando histórico…'
                  : (undoEval?.ok
                    ? `Desfaz a etapa atual (${undoEval.etapaNome}) e volta para ${undoEval.etapaDestinoNome}`
                    : (undoEval?.reason || 'Não há etapa anterior para desfazer'))
              }
              onClick={handleOpenUndo}
            >
              {undoLoading || undoEvalLoading ? (
                <Spinner size="sm" className="mr-1" />
              ) : (
                <i className="ri-arrow-go-back-line mr-1" />
              )}
              Desfazer para a etapa anterior
            </Button>
          </Col>
        </Row>
      )}

      <Dialog
        open={undoOpen}
        onClose={() => {
          if (!undoLoading) setUndoOpen(false)
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Desfazer etapa do produto</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">
            <p style={{ marginBottom: 8 }}>
              Confirma desfazer a etapa{' '}
              <strong>{undoEval?.etapaNome || 'atual'}</strong>
              {undoEval?.etapaDestinoNome
                ? <> e voltar o produto para <strong>{undoEval.etapaDestinoNome}</strong>?</>
                : '?'}
            </p>
            <ul style={{ marginBottom: 0, paddingLeft: 18 }}>
              <li>A última mudança de status será inativada.</li>
              <li>Documentos/arquivos dessa etapa serão inativados.</li>
              <li>Datas registradas nessa etapa serão limpas.</li>
              {Number(undoEval?.ultimo?.prodStatusTp_id) === 8 && (
                <li>
                  Se for a autorização de faturamento e nenhum outro produto do mesmo evento
                  permanecer autorizado, a liberação na receita (<code>rec</code>) será revertida.
                </li>
              )}
            </ul>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button type="button" color="light" disabled={undoLoading} onClick={() => setUndoOpen(false)}>
            Cancelar
          </Button>
          <Button type="button" color="warning" disabled={undoLoading} onClick={handleConfirmUndo}>
            {undoLoading ? <Spinner size="sm" /> : 'Confirmar desfazer'}
          </Button>
        </DialogActions>
      </Dialog>

      <Row className='mt-4'>

        <div className='d-flex flex-column ml-3' style={{fontSize: "13px"}}>
          <span>
            Produto Final:
            {
              prodFinaisLinks &&
              <Button
              title="Produto Final"
              className="ml-2"
              color="light"
              size="sm"
              onClick={(e) => {
              e.preventDefault()
              console.log(prodFinaisLinks);
              downloadFile(`https://oikos.ecoss.is/oikos/${prodFinaisLinks[prodFinaisLinks.length - 1]}`, `${props.produto.prod_desc} REV ${prodFinaisLinks.length - 1}.zip`)
              }}>
                <i className="ri-file-zip-line" />
              </Button>
            }
          </span>
          <span
          className='text-success'
          style={{cursor: "pointer"}}
          onClick={(e) => {
            e.preventDefault()
            setVerMaisProds(prev => !prev)
            }}>
              {prodFinaisLinks &&
                (verMaisProds ? <span>Histórico</span> : <span>Histórico</span>)
              }
          </span>
          {
            verMaisProds && (prodFinaisLinks !== null) && (
              prodFinaisLinks.length > 0 ? (
                prodFinaisLinks.map((link, index) => (
                  <a
                  key={index}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent the default behavior
                    downloadFile(`https://oikos.ecoss.is/oikos/${link}`, `${props.produto.prod_desc} REV ${index}.zip`);
                  }}
                >
                  {props.produto.prod_desc} REV {index}
                </a>
                ))
                ) : (
                  <Spinner size={'sm'}/>
                )
            )
          }
          {!prodFinaisLinks && <strong>Arquivo não encontrado</strong>}
        </div>
        <div className='d-flex flex-column ml-3' style={{fontSize: "13px"}}>
          <span>
            Parecer do cliente:
            {
              evidenceLinks &&
              <Button
              title="Parecer Cliente"
              className="ml-2"
              color="light"
              size="sm"
              onClick={(e) => {
              e.preventDefault()
              downloadFile(`https://oikos.ecoss.is/oikos/${evidenceLinks[evidenceLinks.length - 1]}`, `${props.produto.prod_desc} Evidencia ${evidenceLinks.length}`)
              }}>
                <i className="ri-clipboard-line"/>
              </Button>
            }
          </span>
          <span
          className='text-success'
          style={{cursor: "pointer"}}
          onClick={(e) => {
            e.preventDefault()
            setVerMaisPareceres(prev => !prev)
            }}>
              {
                evidenceLinks &&
                (verMaisPareceres ? <span>Pareceres</span> : <span>Pareceres</span>)
              }
          </span>
          {
            verMaisPareceres && (evidenceLinks !== null) && (
              evidenceLinks.length > 0 ? (
                evidenceLinks.map((link, index) => (
                  <a
                  key={index}
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // Prevent the default behavior
                    downloadFile(`https://oikos.ecoss.is/oikos/${link}`, `${props.produto.prod_desc} Evidencia ${index + 1}`);
                  }}
                >
                  {props.produto.prod_desc} Evidência {index + 1}
                </a>
                ))
                ) : (
                  <Spinner size={'sm'}/>
                )
            )
          }
          {!evidenceLinks && <strong>Parecer não encontrado</strong>}
        </div>
      </Row>
    </>

  )
};

export default StepProgress;
